/** biome-ignore-all lint/style/noRestrictedImports: This is the wrapper file for typeid-js */

import { fromString, fromUUID, getType, type TypeId, toUUID, typeidUnboxed } from "typeid-js";
import { UnexpectedError } from "../domain/error/errors.ts";

export type { TypeId } from "typeid-js";

export function tryParseTypeId<T extends string>(id: unknown, type: T): TypeId<T> | null {
  if (typeof id !== "string") {
    return null;
  }
  try {
    return fromString(id, type);
  } catch {
    return null;
  }
}

export function parseTypeId<T extends string>(id: unknown, type: T): TypeId<T> {
  if (typeof id !== "string") {
    throw new UnexpectedError(`Invalid TypeId: expected string but got ${typeof id}`);
  }
  return fromString(id, type);
}

export function isTypeId<T extends string>(id: unknown, type: T): id is TypeId<T> {
  return Boolean(tryParseTypeId(id, type));
}
export { fromString, fromUUID, getType, toUUID, typeidUnboxed as typeid };
